module.exports = __webpack_public_path__ + "img/login_succ2.2f1041cb.png";